/* global someFunction _hmt:true */
/**
 * trackEvent 百度埋点
 * @param category   要监控的目标的类型名称，通常是同一组目标的名字，比如”视频”、”音乐”、”软件”、”游戏”等等。该项必选。
 * @param action     用户跟目标交互的行为，如”播放”、”暂停”、”下载”等等。该项必选。
 * @param opt_label  事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
 * @param opt_value  事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选
 */
import { SOURCE } from './config';
// 判断定制 区分埋点
let source = '';
switch (SOURCE) {
  case 'yonyou':
    source = 'yy-';
    break;
}
export const trackEvent = (category, action, opt_label, opt_value) => {
  _hmt.push(['_trackEvent', `${source}${category}`, action, opt_label, opt_value]);
}



// WEBPACK FOOTER //
// ./src/lib/trackEvent.js